/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Seccion_Home from "./Secciones/Seccion_Home";
import Barra from "./Barra/Barra";
import Footer from "./Tarjetas/Footer";
import {BrowserRouter as Router, Route, Routes} from 'react-router';
import Seccion_Detalle from "./Secciones/Seccion_Detalle";
import Seccion_Catalogo from "./Secciones/Seccion_Catalogo";
import Seccion_Blog from "./Secciones/Seccion_Blog";
import {useCarritoFlotante} from "../Modulo_Carrito_Flotante/Hooks/useCarritoFlotante";
import Seccion_Resultados from "./Secciones/Seccion_Resultados";
import {iniciarPago} from "../Modulo_Mercado_Pago/Funciones/iniciarPago";

const Pagina = () => {
    const {CarritoFlotante} = useCarritoFlotante();

    const enviarPago = async () => {

        let dox = await iniciarPago()
        if (dox.res) {
            window.open(dox.data, "_blank");
        }

    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >

            <Router>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2}}>
                    <Barra/>
                </Grid>


                <Routes>
                    <Route path={"*"} element={<Seccion_Home/>}/>
                    <Route path={"/Detalle/:id"} element={<Seccion_Detalle/>}/>
                    <Route path={"/Catalogo"} element={<Seccion_Catalogo/>}/>
                    <Route path={"/Resultados/:id"} element={<Seccion_Resultados/>}/>
                    <Route path={"/Blog/:id"} element={<Seccion_Blog/>}/>
                    <Route path={"/Blog"} element={<Seccion_Blog/>}/>
                </Routes>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    {/*} <Button
                        onClick={() => enviarPago()}
                    >
                        Pagar
                    </Button>*/}
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Footer/>
                </Grid>

                <CarritoFlotante/>


            </Router>

        </Grid>
    )

}
export default Pagina